module.exports = __webpack_public_path__ + "static/media/Seam_5043.0f86c3d4.jpg";